import type { SourceReference } from "@moneymap/domain";

export const GLOBAL_SOURCES: Readonly<Record<string, SourceReference>> = {
  "oecd-financial-education": {
    id: "oecd-financial-education",
    title: "Financial education",
    publisher: "OECD",
    url: "https://www.oecd.org/en/topics/financial-education.html",
    reviewedOn: "2026-09-07",
    appliesTo: "global"
  },
  "world-bank-financial-inclusion": {
    id: "world-bank-financial-inclusion",
    title: "Financial inclusion overview",
    publisher: "World Bank",
    url: "https://www.worldbank.org/ext/en/topic/financial-sector/financial-inclusion",
    reviewedOn: "2026-09-07",
    appliesTo: "global"
  }
};

export function getGlobalSource(id: string): SourceReference | undefined {
  return GLOBAL_SOURCES[id];
}
